import { Contact } from '@eigtech/contacts-types'
import { getContactEmailAddress, getContactPhoneNumber } from '@eigtech/contacts-util'
import { getContactName } from '../utils/getContactName'
import { getContactRoleLabel } from '../utils/getContactRoleLabel'
import { getPreferredContactMethod } from '../utils/getPreferredContactMethod'

export type AugmentedContact = Omit<Contact, 'description'> & {
  primaryEmail?: string
  primaryPhoneNumber?: string
  contactName: string
  preferredContact: string
  labeledRoles: string[]
  rolesString: string
  description: string
}

export const augmentContact = (contact: Contact): AugmentedContact => ({
  picture: '',
  ...contact,
  description: contact.description ?? '',
  metadata: {
    licenseNumber: '',
    inactive: !!contact.metadata.inactive,
    removed: !!contact.metadata.removed,
    ...contact.metadata,
  },
  contactName: getContactName(contact),
  preferredContact: getPreferredContactMethod(contact),
  labeledRoles: contact.roles.map(getContactRoleLabel),
  rolesString: contact.roles.map(getContactRoleLabel).join(', '),
  primaryEmail: getContactEmailAddress(contact),
  primaryPhoneNumber: getContactPhoneNumber(contact),
})
